import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  Button,
  CircularProgress,
  TableSortLabel,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [selectedUsers, setSelectedUsers] = useState({});
  const navigate = useNavigate();

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const response = await fetch("https://api.egosaferelationship.com/admin/users", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      setUsers(data);
    } catch (err) {
      console.error("Failed to fetch users:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleSort = (key) => {
    const isAsc = sortConfig.key === key && sortConfig.direction === "asc";
    setSortConfig({ key, direction: isAsc ? "desc" : "asc" });
  };

  const sortedUsers = [...users].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const valA = a[sortConfig.key]?.toString().toLowerCase();
    const valB = b[sortConfig.key]?.toString().toLowerCase();
    if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
    if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const toggleUser = (userId) => {
    setSelectedUsers((prev) => ({ ...prev, [userId]: !prev[userId] }));
  };

  const handleDeactivate = async () => {
    const token = localStorage.getItem("adminToken");
    const updates = Object.entries(selectedUsers).filter(
      ([id, checked]) => checked
    );
    for (let [userId] of updates) {
      try {
        await fetch(`https://api.egosaferelationship.com/admin/users/${userId}`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ is_deleted: true }),
        });
      } catch (error) {
        console.error("Failed to update user:", error);
      }
    }
    fetchUsers();
    setSelectedUsers({});
  };

  return (
    <Box p={3} component={Paper} elevation={2}>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Button variant="contained" onClick={() => navigate("/requests")}>
          Connection Requests
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={() => navigate("/")}
        >
          Logout
        </Button>
      </Box>
      <Typography variant="h5" gutterBottom>
        User Management
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel
                    active={sortConfig.key === "first_name"}
                    direction={sortConfig.direction}
                    onClick={() => handleSort("first_name")}
                  >
                    Full Name
                  </TableSortLabel>
                </TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Gender</TableCell>
                <TableCell>Last Login</TableCell>
                <TableCell>Pending CRs</TableCell>
                <TableCell>Deactivate</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedUsers.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>
                    {user.first_name} {user.last_name}
                  </TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.phone_number || "-"}</TableCell>
                  <TableCell>{user.gender}</TableCell>
                  <TableCell>
                    {user.last_login
                      ? new Date(user.last_login).toLocaleDateString()
                      : "-"}
                  </TableCell>
                  <TableCell>{user.pending_crs ?? "-"}</TableCell>
                  <TableCell>
                    <Checkbox
                      checked={!!selectedUsers[user.id]}
                      onChange={() => toggleUser(user.id)}
                      color="error"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Button
            variant="contained"
            color="error"
            onClick={handleDeactivate}
            sx={{ mt: 2 }}
          >
            Update
          </Button>
        </>
      )}
    </Box>
  );
};

// I REMOVED THIS BUTTON from line 91 SINCE EXPIRATION INTERVAL SCREEN IS NOT READY
//     <Button
//         variant="contained"
//          onClick={() => navigate("/expiration-intervals")}
//       Expiration Intervals>
//
//       </Button>///
export default UserManagement;
